import { render, staticRenderFns } from "./side-bar-projects.vue?vue&type=template&id=b4547954&scoped=true&"
import script from "./side-bar-projects.vue?vue&type=script&lang=js&"
export * from "./side-bar-projects.vue?vue&type=script&lang=js&"
import style0 from "./side-bar-projects.vue?vue&type=style&index=0&id=b4547954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4547954",
  null
  
)

component.options.__file = "side-bar-projects.vue"
export default component.exports